import { PartialTheme } from '@fluentui/react/lib/Theme';
import { intranetAiDarkTheme, intranetAiTheme } from './themes/intranet-themes';
import { albiniDarkTheme, albiniTheme } from './themes/albini-themes';
import { supsiDarkTheme, supsiTheme } from './themes/supsi-themes';

export class ApplicationTheme {
    public static THEMES = {
        IAI_APPLICATION: "IAI_APPLICATION",
        ALBINI: "ALBINI",
        SUPSI: "SUPSI"
    };

    public static partialTheme = (theme: string): PartialTheme => {
        switch (theme) {
            case ApplicationTheme.THEMES.IAI_APPLICATION: return intranetAiTheme;
            case ApplicationTheme.THEMES.ALBINI: return albiniTheme;
            case ApplicationTheme.THEMES.SUPSI: return supsiTheme;

            default: return intranetAiTheme;
        }
    };

    public static partialThemeDark = (theme: string): PartialTheme => {
        switch (theme) {
            case ApplicationTheme.THEMES.IAI_APPLICATION: return intranetAiDarkTheme;
            case ApplicationTheme.THEMES.ALBINI: return albiniDarkTheme;
            case ApplicationTheme.THEMES.SUPSI: return supsiDarkTheme;

            default: return intranetAiDarkTheme;
        }
    };

    public static themeResourcesRoot = (theme: string): string => {
        switch (theme) {
            case ApplicationTheme.THEMES.IAI_APPLICATION: return 'intranet.ai';
            case ApplicationTheme.THEMES.ALBINI: return 'albini';
            case ApplicationTheme.THEMES.SUPSI: return 'supsi';

            default: return 'iai';
        }
    };
}